import { type Position } from './getPositionsService'

import { handleHttpRequest, http, type HttpResponse } from 'interfaces'

export async function createPositionService (orgId: number, position: Position): Promise<HttpResponse<Position[]>> {
  delete position.lastUpdated
  delete position.updatedBy
  return await handleHttpRequest(http.post(`/api/v1/organizations/${orgId}/positions/`, {
    ...position
  }))
}

export async function updatePositionService (orgId: number, originalPosition: Position): Promise<HttpResponse<Position[]>> {
  const position: Position = JSON.parse(JSON.stringify(originalPosition))

  delete position.lastUpdated
  delete position.updatedBy
  if (position.address != null && position.address?.phone?.id == null && position.address?.phone?.phoneNumber?.trim() === '') {
    position.address.phone = null
  }
  if (position.person == null) {
    delete position.person
  }

  return await handleHttpRequest(http.patch(`/api/v1/organizations/${orgId}/positions/${position.id}/`, {
    ...position
  }))
}
